/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Tax_Id_BusinessInputs */

const en_label_tax_id_business = /** @type {(inputs: Label_Tax_Id_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tax ID (VAT / EIN / ABN)`)
};

const es_label_tax_id_business = /** @type {(inputs: Label_Tax_Id_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID Fiscal (CIF / NIF)`)
};

const fr_label_tax_id_business = /** @type {(inputs: Label_Tax_Id_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID Fiscal (TVA / SIRET)`)
};

const de_label_tax_id_business = /** @type {(inputs: Label_Tax_Id_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`USt-IdNr. (VAT / EIN)`)
};

const id_label_tax_id_business = /** @type {(inputs: Label_Tax_Id_BusinessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NPWP`)
};

/** @type {(inputs: Label_Tax_Id_BusinessInputs) => LocalizedString} */
const ja_label_tax_id_business = en_label_tax_id_business;

/** @type {(inputs: Label_Tax_Id_BusinessInputs) => LocalizedString} */
const zh_label_tax_id_business = en_label_tax_id_business;

/** @type {(inputs: Label_Tax_Id_BusinessInputs) => LocalizedString} */
const ar_label_tax_id_business = en_label_tax_id_business;

/** @type {(inputs: Label_Tax_Id_BusinessInputs) => LocalizedString} */
const it_label_tax_id_business = en_label_tax_id_business;

/** @type {(inputs: Label_Tax_Id_BusinessInputs) => LocalizedString} */
const ru_label_tax_id_business = en_label_tax_id_business;

/** @type {(inputs: Label_Tax_Id_BusinessInputs) => LocalizedString} */
const pt_label_tax_id_business = en_label_tax_id_business;

/** @type {(inputs: Label_Tax_Id_BusinessInputs) => LocalizedString} */
const ko_label_tax_id_business = en_label_tax_id_business;

/**
* | output |
* | --- |
* | "Tax ID (VAT / EIN / ABN)" |
*
* @param {Label_Tax_Id_BusinessInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const label_tax_id_business = /** @type {((inputs?: Label_Tax_Id_BusinessInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Tax_Id_BusinessInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_label_tax_id_business(inputs)
	if (locale === "es") return es_label_tax_id_business(inputs)
	if (locale === "fr") return fr_label_tax_id_business(inputs)
	if (locale === "de") return de_label_tax_id_business(inputs)
	if (locale === "ja") return ja_label_tax_id_business(inputs)
	if (locale === "zh") return zh_label_tax_id_business(inputs)
	if (locale === "ar") return ar_label_tax_id_business(inputs)
	if (locale === "id") return id_label_tax_id_business(inputs)
	if (locale === "it") return it_label_tax_id_business(inputs)
	if (locale === "ru") return ru_label_tax_id_business(inputs)
	if (locale === "pt") return pt_label_tax_id_business(inputs)
	return ko_label_tax_id_business(inputs)
});